import { render, staticRenderFns } from "./GarageDoorIsFunctional.vue?vue&type=template&id=1bb47689&scoped=true"
import script from "./GarageDoorIsFunctional.vue?vue&type=script&lang=ts"
export * from "./GarageDoorIsFunctional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb47689",
  null
  
)

export default component.exports